var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3828 23.25L4.86719 33H35.1328L25.3828 20L17.8672 29.75L12.3828 23.25ZM39.5 35.1328C39.5 36.2839 39.0599 37.2995 38.1797 38.1797C37.2995 39.0599 36.2839 39.5 35.1328 39.5H4.86719C3.71615 39.5 2.70052 39.0599 1.82031 38.1797C0.940104 37.2995 0.5 36.2839 0.5 35.1328V4.86719C0.5 3.71615 0.940104 2.70052 1.82031 1.82031C2.70052 0.940104 3.71615 0.5 4.86719 0.5H35.1328C36.2839 0.5 37.2995 0.940104 38.1797 1.82031C39.0599 2.70052 39.5 3.71615 39.5 4.86719V35.1328Z",
    fill: "#DEDFE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertPhoto);
export default __webpack_public_path__ + "static/media/insert-photo.7738f4ee.svg";
export { ForwardRef as ReactComponent };